<template>
    <v-row justify="space-between" align="center" class="my-6">
        <v-col cols="auto" ><CreateSingleCustomer @created="$emit('added')"/></v-col>
        <v-col cols="auto"><CreateMultipleCustomers @created="$emit('added')"/></v-col>
    </v-row>
</template>

<script>
import CreateSingleCustomer from '@/components/customers/CreateSingleCustomer';
import CreateMultipleCustomers from '@/components/customers/CreateMultipleCustomers';

/**
 * AddCustomer includes the components of CreateSingleCustomer and 
 * CreateMultipleCustomers to place them together.
 */
export default {
    name: 'AddCustomers',
    data: () => ({
        dialog: false
    }),
    components: { CreateSingleCustomer, CreateMultipleCustomers }
}
</script>